/**
 * Game Player operations — normalized `game_player` table (audit M8 / B7).
 *
 * Authoritative source for the per-game player list. Replaces reads from
 * the legacy `game.players` UUID[] column on the `game` row.
 */

import type { SupabaseClient } from "@supabase/supabase-js"
import { getClient } from "../get-client"

/**
 * Fetch the player IDs that have joined a given game, ordered by join time.
 *
 * The legacy `game.players` array preserved insertion order; we replicate
 * that by ordering on `joined_at` so consumers (PlayersList,
 * WinnerCelebration, EndScreen, useWinner) keep the same UX — first to
 * join is host, etc.
 */
export const getGamePlayers = async (
  gameId: string,
  supabase: SupabaseClient | null = null
): Promise<string[]> => {
  const client = supabase || getClient()
  const { data, error } = await client
    .from("game_player")
    .select("player_id, joined_at")
    .eq("game_id", gameId)
    .order("joined_at", { ascending: true })

  if (error) {
    console.error("[getGamePlayers] fetch error:", error)
    return []
  }

  return (data || []).map(row => String(row.player_id))
}
